import Layout from '../../components/Layout';
import DocumentForm from './DocumentForm';

export default function DocumentPage() {
  return (
    <Layout variant="calculator">
      <DocumentForm />
    </Layout>
  );
};
